import { CustomSnackbarProvider } from "@redotech/redo-web/snackbar";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";
import { stripTokenFromUrl } from "./strip-token";
import "./styles.css";

// The router has already read the URL, so the verify page still gets the
// sign-in token; removing it from the address bar keeps it out of history.
stripTokenFromUrl();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}

createRoot(container).render(
  <QueryClientProvider client={queryClient}>
    <CustomSnackbarProvider>
      <RouterProvider router={router} />
    </CustomSnackbarProvider>
  </QueryClientProvider>,
);
